'use strict';
import Script from 'next/script';
const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

const GoogleAnalyticsBase = () => {
  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`} />
      <Script id="gtag-script">
        {`
              window.dataLayer = window.dataLayer || [];
              function gtag() {
                dataLayer.push(arguments);
              }
              gtag('js', new Date());
              gtag('config', "${GA_MEASUREMENT_ID}");

              // https://support.google.com/analytics/answer/7478520?hl=en
              // Great tool when we want to track a link click and open in
              var getOutboundLink = function(url, category, openNewWindow, target) {
                gtag('event', 'click', {
                  'event_category': category || 'outbound',
                  'event_label': url,
                  'transport_type': 'beacon'
                });
                openNewWindow ? window.open(url, target) : false;
                return false;
              }
            `}
      </Script>
    </>
  );
};

module.exports = GoogleAnalyticsBase;
